// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__327Cz","sendOtp":"AuthorizeToLogin_sendOtp__2hVfC"};